import React from "react";
import { ToastContentProps } from "./Toast.types";
import { Content as StyledContent } from "./Content.styles";

/**
 * Provides a basic layout for the main content of a toast
 */
export const Content = ({ children, className }: ToastContentProps) => (
  <StyledContent className={className}>{children}</StyledContent>
);
